export const selectTrainStopSignalImages = (state) =>
  state.trainStopSignalImages?.trainStopSignalImages || [];

export const selectIsLoadingTrainStopSignalImages = (state) =>
  state.trainStopSignalImages?.loadingTrainStopSignalImages;

export const selectStations = (state) =>
  state.trainStopSignalImages?.stations || [];

export const selectIsLoadingStations = (state) =>
  state.trainStopSignalImages?.loadingStations;
